import ShadowWrapper from "components/Common/ShadowWrapper";
import { useModal } from "src/hooks/useModal";


const PrivacyComp = () => {
  const { openPrivacyPolicy } = useModal();
  const htmlContent = `
    <!doctype html>
<html lang="ko">
  <head>
    <meta charset="UTF-8" />
    <title>주식회사 파수에이아이 클라우드 서비스 통합 개인정보 처리방침 개정 안내</title>
    <style>
      /* 첨부파일의 스타일 시트를 그대로 유지합니다 */
      html, body, div, span, object, iframe, h1, h2, h3, h4, h5, h6, blockquote, pre, abbr, address, cite, code, del, dfn, em, img, ins, kbd, q, samp, small, strong, sub, sup, var, b, i, a, dl, dt, dd, fieldset, form, label, legend, table, caption, tbody, tfoot, thead, tr, th, td, article, aside, canvas, details, figcaption, figure, footer, header, hgroup, menu, nav, section, summary, time, mark, audio, video {
        margin: 0; padding: 0; border: 0; outline: 0; text-decoration: none;
      }
      table { border-collapse: collapse; width: 100%; }
      body { font-family: "Noto Sans KR", Sans-serif; color: #333; }
      h1 { font-size: 24px; text-align: center; padding: 40px 0 20px 0; }
      .summary-box { width: 90%; margin: 0 auto 30px auto; padding: 25px; background-color: #f9f9f9; border: 1px solid #eee; border-radius: 8px; }
      .summary-item { margin-bottom: 15px; }
      .summary-item:last-child { margin-bottom: 0; }
      .summary-title { font-weight: bold; font-size: 15px; margin-bottom: 8px; color: #000; display: block; }
      .summary-content { font-size: 14px; line-height: 1.6; color: #666; list-style: none; }
      .summary-content li { position: relative; padding-left: 12px; }
      .summary-content li::before { content: "•"; position: absolute; left: 0; color: #ccc; }
      .data-tb { width: 90%; margin: 20px auto; overflow-x: auto; }
      .data-tb table, .data-tb th, .data-tb td { border: 1px solid #ececec; font-size: 14px; line-height: 1.6; }
      .data-tb th { padding: 12px 10px; background-color: rgba(185, 185, 185, 0.08); }
      .data-tb td { padding: 15px 20px; font-size: 13px; vertical-align: top; }
      .data-tb table th.color { font-weight: bold; background-color: rgba(61, 219, 135, 0.08); }
      .data-tb table th.color-yellow { font-weight: bold; background-color: rgba(242, 255, 125, 0.08); }
      .highlight { color: #e74c3c; font-weight: bold; }
    </style>
  </head>
  <body>
    <h1>주식회사 파수에이아이 클라우드 서비스 통합 개인정보 처리방침 개정 안내</h1>

    <div class="summary-box">
      <div class="summary-item">
        <span class="summary-title">1. 개정 사유</span>
        <ul class="summary-content">
          <li>서비스 운영 주체(법인명) 변경에 따른 개인정보 처리방침 전면 개편</li>
          <li>통합 클라우드 서비스(Wrapsody, Mind-SAT 등) 체계로의 단일 방침 적용</li>
          <li>최신 개인정보 보호법 개정 사항 반영(전송요구권, 국외 이전 조항 등)</li>
          <li>사용자 데이터의 AI 학습 미사용 정책 수립 및 공표</li>
        </ul>
      </div>
      <div class="summary-item">
        <span class="summary-title">2. 주요 개정 항목</span>
        <ul class="summary-content">
          <li><strong>제1조 (수집 항목/목적):</strong> 결제 정보, 접속 로그 등 수집 항목 구체화 및 계약 이행 목적 명시</li>
          <li><strong>제2조 (AI 학습 제한):</strong> 외부 API 연동 데이터 및 사용자 데이터의 AI/ML 학습 활용 금지 조항 신설</li>
          <li><strong>제4조/제6조 (위탁 및 국외 이전):</strong> AWS, Oracle, Paypal 등 글로벌 서비스 인프라 활용에 따른 국외 이전 사항 명시</li>
          <li><strong>제7조 (권리 의무):</strong> 개인정보 전송요구권 및 자동화된 결정에 대한 설명 요구/거부권 추가</li>
        </ul>
      </div>
      <div class="summary-item">
        <span class="summary-title">3. 시행 일자</span>
        <ul class="summary-content">
          <li><strong>2026년 06월 01일</strong></li>
        </ul>
      </div>
     <div style="margin-top: 20px; padding-top: 15px; border-top: 1px dashed #ddd; text-align: right;">
  <a id="privacy-policy-link" style="color: #e74c3c; font-weight: bold; text-decoration: underline; cursor: pointer;">
    개정 개인정보 처리방침 전문 보기 >
  </a>
</div>
    </div>

    <div class="data-tb">
      <h3>주요 변경 사항 요약표</h3>
      <table>
        <colgroup>
          <col width="15%" />
          <col width="35%" />
          <col width="35%" />
          <col width="15%" />
        </colgroup>
        <thead>
          <tr>
            <th>구분</th>
            <th>현행 (구 방침)</th>
            <th class="color">개정안 (2026년 06월 01일 시행)</th>
            <th class="color-yellow">주요 변경 내용</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td><strong>방침 명칭 및 주체</strong></td>
            <td>주식회사 파수 개인정보 처리방침</td>
            <td><strong class="highlight">주식회사 파수에이아이 클라우드 서비스 통합</strong> 개인정보 처리방침</td>
            <td>사명 변경 반영 및 통합 클라우드 서비스 범위 명시</td>
          </tr>
          <tr>
            <td><strong>수집 항목 및 방법</strong></td>
            <td>이름, 이메일, 전화번호 등 기본 정보</td>
            <td>기본 정보 외 <strong class="highlight">결제 정보(카드정보 등), 서비스 이용 기록, 접속 IP, 쿠키</strong> 추가</td>
            <td>유료 결제 및 서비스 보안성 확보를 위한 항목 추가</td>
          </tr>
          <tr>
            <td><strong>AI 데이터 활용 정책</strong></td>
            <td>(해당 내용 없음)</td>
            <td><strong class="highlight">사용자 데이터를 일반화된 AI/ML 모델 개발 및 학습 목적으로 사용하지 않음</strong></td>
            <td>데이터의 독립성 보장 및 AI 학습 제한 정책 신설</td>
          </tr>
          <tr>
            <td><strong>개인정보 처리 위탁</strong></td>
            <td>원칙적으로 외부 제공하지 않음</td>
            <td><strong class="highlight">AWS, Oracle, KG이니시스, Paypal, (주)알리는사람들</strong> 위탁 운영 명시</td>
            <td>클라우드 인프라 및 결제, 안내 발송 전문업체 위탁 명시</td>
          </tr>
          <tr>
            <td><strong>국외 이전</strong></td>
            <td>(해당 조항 없음)</td>
            <td><strong class="highlight">미국 내 Amazon Web Services, Paypal, Oracle Corporation</strong>으로의 이전(위탁/보관) 명시</td>
            <td>글로벌 인프라 활용에 따른 국외 이전 필수 고지 사항 신설</td>
          </tr>
          <tr>
            <td><strong>정보주체 권리</strong></td>
            <td>열람, 정정, 삭제 및 가입해지 권리</td>
            <td>기존 권리 외 <strong class="highlight">개인정보 전송요구권, 자동화된 결정에 대한 설명 요구 및 거부권</strong> 추가</td>
            <td>법령 개정에 따른 정보주체의 능동적 권리 강화</td>
          </tr>
          <tr>
            <td><strong>개인정보 보존 기간</strong></td>
            <td>목적 달성 후 지체 없이 파기</td>
            <td>관계 법령에 따른 <strong class="highlight">구체적 보존 기간(3개월~5년) 명시</strong></td>
            <td>통신비밀보호법, 전자상거래법 등 법정 의무 보관 기준 적용</td>
          </tr>
          <tr>
            <td><strong>방침 개정 고지 기준</strong></td>
            <td>개정 시 웹사이트 공지</td>
            <td>일반 변경 <strong class="highlight">7일 전</strong>, 중요 변경 <strong class="highlight">30일 전</strong> 사전 고지 의무화</td>
            <td>정보주체의 알 권리 보장 및 법적 고지 기간 세분화</td>
          </tr>
        </tbody>
      </table>
    </div>
  </body>
</html>
`;
  const handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
    // shadow DOM 내부에 있는 엘리먼트 클릭을 감지하기 위해 composedPath 사용
    const path = e.nativeEvent.composedPath() as HTMLElement[];
    const isLinkClick = path.some((el) => el.id === "privacy-policy-link");

    if (isLinkClick) {
      openPrivacyPolicy("2026");
    }
  };
  return (
    <div style={{ fontFamily: "Noto Sans KR" }} onClick={handleClick}>
      <ShadowWrapper htmlContent={htmlContent} />
    </div>
  );
};
export default PrivacyComp;
